import { render, staticRenderFns } from "./ButtonAddShop.vue?vue&type=template&id=484d4734&scoped=true&"
import script from "./ButtonAddShop.vue?vue&type=script&lang=js&"
export * from "./ButtonAddShop.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAddShop.vue?vue&type=style&index=0&id=484d4734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d4734",
  null
  
)

export default component.exports